import React, { useEffect } from 'react'
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui'
import { useWallet } from '@solana/wallet-adapter-react'
import { useAdmin } from '../hooks/use-admin'
import { Link } from 'react-router-dom'
import '../styles/8bit.css'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  const { publicKey } = useWallet()
  const { isAdmin, loading } = useAdmin()
  const [mounted, setMounted] = React.useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <div className="bit-screen">
      <nav className="bit-nav">
        <div className="bit-container">
          <div className="bit-nav-content">
            <div className="bit-logo-container">
              <div className="bit-logo">
                <img src="https://www.ai16ava.fun/logo.png" height="40" />
              </div>
              <h1 className="bit-title">Ai16AVA Vesting</h1>
            </div>
            {publicKey && (
              <div className="bit-menu-container">
                <div className="bit-menu">
                  <Link to="/vesting" className="bit-menu-item">
                    <span className="bit-menu-text">Vesting</span>
                    <span className="bit-menu-arrow">▶</span>
                  </Link>
                  {!loading && isAdmin && (
                    <Link to="/admin" className="bit-menu-item">
                      <span className="bit-menu-text">Admin</span>
                      <span className="bit-menu-arrow">▶</span>
                    </Link>
                  )}
                </div>
                <WalletMultiButton />
              </div>
            )}
            {!publicKey && <WalletMultiButton />}
          </div>
        </div>
      </nav>
      <main className="bit-container">
        {children}
      </main>
    </div>
  )
} 
